const c = {
  name: "Truck",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h27v7h6.4l6.6,5.5V30h-4.1c-0.5,2.3-2.5,4-4.9,4s-4.4-1.7-4.9-4H15.9c-0.5,2.3-2.5,4-4.9,4
			c-2.4,0-4.4-1.7-4.9-4H2v-6H0V0z M34,28.7c-0.1-1.4-1.3-2.6-2.8-2.7c-0.1,0-0.2,0-0.2,0c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3
			s3-1.3,3-3C34,28.9,34,28.8,34,28.7z M35.9,28H38v-6h-9V9h-2v15H11c0.1,0,0.3,0,0.4,0c2.2,0.2,4.1,1.8,4.5,4h10.2
			c0.4-2.2,2.3-3.8,4.5-4c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0C33.6,24.2,35.5,25.8,35.9,28z M38,20v-6.5L32.6,9H31v11H38z M11,24H4
			v4h2.1c0.4-2.2,2.3-3.8,4.5-4C10.7,24,10.9,24,11,24z M8,29c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3C9.3,26,8,27.3,8,29z
			 M25,2H2v20h23V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Truck
};
